import axios from "axios";
import { handleResponse, extractData, handleApiException } from "helpers/apiResponseHelper";
import { CustomerMeteringPoints, MeteringPointMeasurementResolution, MeteringPointMeasurements } from "models/electricity/metering-point";
import { apiService } from "services/api.service";

async function getCustomerMeteringPoints(customerId: number): Promise<CustomerMeteringPoints> {
    return axios.get(apiService.getApiUrl() + '/electricity/metering-points/' + customerId)
        .then(handleResponse).then(extractData).catch(handleApiException);
}

async function getCustomerMeteringPointMeasurements(customerId: number, meteringPointId: number,
    startDate: string, endDate: string, resolution?: MeteringPointMeasurementResolution): Promise<MeteringPointMeasurements> {

    return axios.get(apiService.getApiUrl() + '/electricity/metering-points/' + customerId + '/measurements/' + meteringPointId,
        {
            params: {
                startDate, endDate, resolution
            }
        }).then(handleResponse).then(extractData).catch(handleApiException);
}

const MeteringPointService = {
    getCustomerMeteringPoints,
    getCustomerMeteringPointMeasurements
};

export default MeteringPointService;
